import 'reflect-metadata';
import {jsonObject, jsonMember} from 'typedjson';

@jsonObject
export class NtpServer {

  @jsonMember({name: 'address'})
  public Address: string = '';

  @jsonMember({name: 'parameters'})
  public Parameters: string = '';
}
